import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

export const dayFormat = (value) => {
  if (value) return dayjs(value).format("MMM/DD/YYYY h:mm A");
};

export const dayFormatV2 = (value) => {
  dayjs.extend(utc);
  dayjs.extend(timezone);

  if (value) return dayjs(value).tz("Asia/Calcutta").format("MMM D, YYYY");
};

export const unixTime = (value) => {
  // console.log(dayjs().unix(value));
  // if (value) return dayjs().unix(value);
  if (value) return dayjs.unix(value).format("MMM D,YYYY");
};

export const timeFormat = (value) => {
  if (value) return dayjs(value).format("hh:mm A");
};

export const DatetimeFormat = (value) => {
  if (value) return dayjs(value).format("MMM D hh:mm A");
};

export const IsoToIst = (value) => {
  dayjs.extend(utc);
  dayjs.extend(timezone);

  if (value)
    return dayjs(value).tz("Asia/Calcutta").format("MMM D, YYYY h:mm A");
};

export const UtcToEst = (value) => {
  dayjs.extend(utc);
  dayjs.extend(timezone);

  const utcDatetime = dayjs.utc(value);

  if (utcDatetime)
    return dayjs(utcDatetime)
      .tz("America/New_York")
      .format("MMM D, YYYY h:mm A");
};

export const IsoToUtc = (value) => {
  dayjs.extend(utc);
  dayjs.extend(timezone);

  if (value) return dayjs.utc(value).format("MMM D, YYYY h:mm A");
};
